export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/partner', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getPartnerList = async (searchText) => {
    try {
        const result = await get(`partner${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getPartnerContent = async (newsId) => {
    try {
        const result = await get(`partner/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createPartner = async (data) => {
    try {
        const result = await post('partner', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updatePartner = async (id, data) => {
    try {
        const result = await put(`partner/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deletePartner = async (id) => {
    try {
        const result = await destroy(`partner/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`partner/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
